import * as React from 'react';
import { isSlot, SLOT_ELEMENT_TYPE_SYMBOL, SLOT_RENDER_FUNCTION_SYMBOL } from '@fluentui/react-utilities';
export function createElement(type, props, ...children) {
    // TODO:
    // this is for backwards compatibility with getSlotsNext
    // it should be removed once getSlotsNext is obsolete
    if (isSlot(props)) {
        return createElementFromSlotComponent({
            ...props,
            [SLOT_ELEMENT_TYPE_SYMBOL]: type
        }, children);
    }
    if (isSlot(type)) {
        return createElementFromSlotComponent(type, children);
    }
    return React.createElement(type, props, ...children);
}
function createElementFromSlotComponent(type, overrideChildren) {
    const { as , [SLOT_ELEMENT_TYPE_SYMBOL]: baseElementType , [SLOT_RENDER_FUNCTION_SYMBOL]: renderFunction , ...propsWithoutMetadata } = type;
    const props = propsWithoutMetadata;
    const elementType = typeof baseElementType === 'string' ? as !== null && as !== void 0 ? as : baseElementType : baseElementType;
    if (typeof elementType !== 'string' && as) {
        props.as = as;
    }
    if (renderFunction) {
        if (overrideChildren.length > 0) {
            props.children = React.createElement(React.Fragment, {}, ...overrideChildren);
        }
        return React.createElement(React.Fragment, {}, renderFunction(elementType, props));
    }
    return React.createElement(elementType, props, ...overrideChildren);
}
